import { LiveData, useLiveData, useService } from '@toeverything/infra';
import { useMemo } from 'react';

import { AccessibleFolderCacheStore } from '../stores/accessible-folder-cache';

export interface PrivateFolderStorageSnapshot {
  usedBytes: number;
  limitBytes: number | null;
}

export function usePrivateFolderStorage(): PrivateFolderStorageSnapshot | null {
  const accessibleFolderCache = useService(AccessibleFolderCacheStore);
  const accessibleFolders = useLiveData(
    useMemo(
      () =>
        LiveData.from(accessibleFolderCache.watchAllAccessibleFolders(), []),
      [accessibleFolderCache]
    )
  );

  const privateRoot = useMemo(
    () =>
      accessibleFolders.find(folder => folder.systemKind === 'private_root') ??
      null,
    [accessibleFolders]
  );

  if (!privateRoot) {
    return null;
  }

  return {
    usedBytes: privateRoot.storageUsedBytes ?? 0,
    limitBytes: privateRoot.storageLimitBytes,
  };
}
